// shared, render-independent editor constants
// (module scope so every reference is a stable value, in and outside the component)

// usused area size on canvas' border
export const sideOffset = { top: 50, left: 50, bottom: 50, right: 50 };

// a default "null" position for the ghost element
export const ghostBasePos = { posX: -5000, posY: -5000, rotation: 0 };

// the background rectangle reaches this much past the plan on every side (in meters)
export const backgroundMargin = 0.67;

// the mouse tracker lines are drawn far enough to cover any zoom level
export const trackerLineLength = 10000;

// The grid lines are placed by adding the step over and over, so the one that closes the plan
// can land a float tail above the edge it sits on. It still belongs to the plan: the next line
// is a whole step away, so nothing else fits inside this tolerance.
export const gridEdgeTolerance = 1e-6;

// The strip along the top and left edge of the canvas that carries the grid numbers, out of
// the way of the plan.
export const gridLabelStrip = 20;

// The canvas draws its own text (grid labels, coordinate readout), so it cannot inherit the
// page font - it has to name it. Montserrat is what the rest of the app uses (loaded in
// public/index.html); the rest of the stack is there for the moment before it arrives.
export const canvasFontFamily = "Montserrat, Calibri, sans-serif";

// The stage's layers are named so that the plan image the offer carries can say what belongs
// on it and what does not - the helpers that only mean anything under a live mouse pointer are
// left off it. See capturePlanImage.
export const layerNames = {
  background: "background-layer",
  main: "main-layer",
  border: "border-layer",
  grid: "grid-layer",
  tracker: "tracker-layer",
  ghost: "ghost-layer",
};

// How long after the last wheel event the tiles start answering the mouse again. Long enough
// that a continuous scroll never falls into it (a wheel gesture fires far more often than
// this), short enough that the cursor is live again by the time the hand has left the wheel.
export const hitRestoreDelay = 150;

// How often the zoom on the stage is written into React state while the wheel is turning. Ten
// times a second: fast enough that the few things sized off the zoom are never visibly behind,
// rare enough that the components reading the editor context are not re-rendered per event.
export const zoomCommitInterval = 100;
